// extracted by mini-css-extract-plugin
export var cardLayout = "_1r-1";
export var paginationContainer = "_1r-0";